<template>
    <div
        class="public_page text-center"
        :style="{
            'background-image': `url('/assets/images/fe_background.png')`,
        }"
    >
        <img
            src="@/assets/images/linxfour.png"
            class="public_page__logo"
        />

        <main class="public_page__content bg-light">
            <h1
                v-if="heading"
                class="mb-16"
            >
                {{ $t(heading) }}
            </h1>
            <slot></slot>
        </main>
    </div>
</template>

<script>
export default {
    name: 'PublicPageLayout',

    props: { heading: { type: String, default: null } },
}
</script>

<style>
.public_page {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center;

    & .public_page__logo {
        position: absolute;
        left: 3vw;
        top: 0;

        max-width: 250px;
    }

    & .public_page__content {
        position: relative;
        z-index: 1;
        box-shadow: 6px 10px 31px 9px rgba(0, 0, 0, 0.1);
        border-radius: 16px;
        padding: 3.5rem 10rem;
        width: 90%;
        max-width: 80rem;

        & h1 {
            font-weight: 300;
            font-size: 6.4rem;
        }
    }
}

@media (max-width: 768px) {
    .public_page {
        align-items: flex-end;
        overflow-y: auto;
        padding-bottom: 10rem;

        & .public_page__logo {
            position: absolute;
            top: 10%;
            left: 50%;
            transform: translateX(-50%);

            width: 80%;
            max-width: 400px;
        }

        & .public_page__content {
            padding: 2.5rem 2rem;
            width: 80%;

            & h1 {
                font-size: 3.2rem;
            }
        }
    }
}

@media (max-width: 480px) {
    .public_page {
        align-items: flex-end;
        overflow-y: auto;
        padding-bottom: 0;

        & .public_page__content {
            width: 100%;
            max-width: 100%;
            border-radius: 0;
            padding: 4rem 1rem;

            & > h1 {
                font-size: 2.8rem;
                margin-bottom: 4rem;
            }
        }
    }
}
</style>
